import React, { lazy, Suspense } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import { Layout, ConfigProvider, App as AntApp, Spin } from 'antd';
import ptBR from 'antd/locale/pt_BR';

import { UserProvider } from '../../context/useUser';
import { TenantProvider } from '../../context/useTenant';
import {
  AuthenticatedRoute,
  AuthorizedRoute,
  LoginRoot as LoginComponent,
  LogoutRoot as LogoutComponent,
} from '../../domains/auth';

import HeaderComponent from './Header';
import { DomainErrorBoundary } from '../../shared/components/DomainErrorBoundary';
import './App.css';

const { Footer } = Layout;

const StudioLazy = lazy(() =>
  import('../../domains/studio').then(m => ({ default: m.StudioRoot })),
);
const SearchLazy = lazy(() =>
  import('../../domains/search').then(m => ({ default: m.SearchRoot })),
);
const CatalogLazy = lazy(() =>
  import('../../domains/catalog').then(m => ({ default: m.CatalogRoot })),
);
const DiscoverLazy = lazy(() => import('./Discover'));

const DomainSpinner = () => (
  <div style={{ display: 'flex', justifyContent: 'center', padding: 80 }}>
    <Spin size="large" />
  </div>
);

const App = () => {
  return (
    <ConfigProvider locale={ptBR}>
      <AntApp>
        <UserProvider>
          <TenantProvider>
            <Layout style={{ minHeight: '100vh' }} className="App">
              <Router>
                <Switch>
                  <Route path="/" exact render={() => <Redirect to="/login" />} />

                  <Route path="/login" component={LoginComponent} />
                  <Route path="/logout" component={LogoutComponent} />

                  <AuthenticatedRoute
                    path="/:client_id"
                    render={({ match }) => (
                      <>
                        <HeaderComponent route={match} />

                        <Route
                          path="/:client_id"
                          exact
                          render={() => (
                            <Redirect to={`/${match.params.client_id}/content`} />
                          )}
                        />

                        <DomainErrorBoundary domain="app">
                          <Suspense fallback={<DomainSpinner />}>
                            <DomainErrorBoundary domain="discover">
                              <AuthorizedRoute
                                path="/:client_id/discover"
                                scope={match.params.client_id}
                                component={DiscoverLazy}
                              />
                            </DomainErrorBoundary>

                            <DomainErrorBoundary domain="studio">
                              <AuthorizedRoute
                                path="/:client_id/content"
                                scope={match.params.client_id}
                                component={StudioLazy}
                              />
                            </DomainErrorBoundary>

                            <DomainErrorBoundary domain="search">
                              <AuthorizedRoute
                                path="/:client_id/search"
                                scope={match.params.client_id}
                                component={SearchLazy}
                              />
                            </DomainErrorBoundary>

                            <DomainErrorBoundary domain="catalog">
                              <AuthenticatedRoute
                                path="/:client_id/catalog"
                                scope={match.params.client_id}
                                component={CatalogLazy}
                              />
                            </DomainErrorBoundary>
                          </Suspense>
                        </DomainErrorBoundary>

                        <Footer style={{ textAlign: 'center' }}>
                          Desenvolvido por Beonly &copy; 2018-2025
                        </Footer>
                      </>
                    )}
                  />
                </Switch>
              </Router>
            </Layout>
          </TenantProvider>
        </UserProvider>
      </AntApp>
    </ConfigProvider>
  );
};

export default App;
